/**
 * Represents a phone anchor component that displays a phone number and allows the user to call it.
 */
export default class PhoneAnchor {
  /**
   * Creates a new instance of the PhoneAnchor class.
   * @param {string} phoneNumber - The phone number to display.
   */
  constructor() {
    this.anchorId = 'nhs_phoneAnchor';
    this.buttonId = 'nhs_phoneButton';
  }

  /**
   * Sets the phone number and removes any dashes.
   * @param {string} phoneNumber - The phone number to set.
   */
  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber?.replaceAll('-', '');
    this.userFriendlyPhone = phoneNumber;
  }

  /**
   * Reveals the phone number by hiding the button and showing the anchor.
   */
  revealPhone() {
    const anchor = this.getPhoneAnchor();
    const button = this.getPhoneButton();

    button.setAttribute('hidden', 'true');
    anchor.removeAttribute('hidden');
  }

  /**
   * Binds the click event to the phone button.
   */
  bindEvents() {
    const button = this.getPhoneButton();
    button?.addEventListener('click', this.revealPhone.bind(this));

    const anchor = this.getAnchor();
    anchor?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('phoneAnchorClick')));
  }

  /**
   * Gets the phone button element.
   * @returns {HTMLElement} The phone button element.
   */
  getPhoneButton() {
    return document.getElementById(this.buttonId);
  }

  /**
   * Gets the phone anchor element.
   * @returns {HTMLElement} The phone anchor element.
   */
  getPhoneAnchor() {
    return document.getElementById(this.anchorId);
  }

  /**
   * Returns the phone anchor.
   * @returns {string} The phone anchor.
   */
  getAnchor() {
    return this.getPhoneAnchor();
  }

  /**
   * Gets the HTML for the phone anchor component.
   * @returns {string} The HTML for the phone anchor component.
   */
  getHtml() {
    if (!this.phoneNumber) {
      return '';
    }

    return `
      <button type="button" id="${this.buttonId}"  class="btn btn--yellow btn--48-lg">
        Don’t Miss Out!<br> Call the Builder
      </button>
      <a id="${this.anchorId}" data-close href="tel:${this.phoneNumber}" class="btn btn--yellow btn--48-lg" data-qa="CallBuilder" hidden>
        ${this.userFriendlyPhone}
      </a>
    `;
  }
}
